<div class="d-flex d-lg-block d-xl-flex justify-content-between">
  <div class="font-medium text-color-primary">
    <a class="link-black" [routerLink]="[instrumentDetail, indication.isin]">{{ indication.name }}</a>
  </div>
  <div class="opacity-container d-flex justify-content-between" [class.active]="indication.last">
    <div class="mr-2 text-right">
      {{ indication.last | priceScale: indication.priceScale : true }}
    </div>
    <div
      [ngClass]="indication.percent >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }"
      class="mr-2 quoteindicator-variant3 text-right min-w-4"
      zeroBlink
      [val]="indication.last"
    >
      {{ indication.percent >= 0 ? '+' : '' }}{{ indication.percent | number: '1.2-2' }} %
    </div>
    <div class="text-right min-w-4">
      @if (showLeverageBtn) {
        <ng-container *ngTemplateOutlet="leverageBtn; context: { isin: indication.isin, name: indication.name }" />
      } @else if (indication.specialLeverageProduct) {
        <ng-container
          *ngTemplateOutlet="
            leverageBtn;
            context: { isin: indication.specialLeverageProduct.isin, name: indication.specialLeverageProduct.name }
          "
        />
      }
    </div>
  </div>
</div>
<hr class="less-margin" />

<ng-template #leverageBtn let-isin="isin" let-name="name">
  <a class="link-black" [routerLink]="leverageProductsPage" [queryParams]="{ isin, name }">
    <span class="highlighted">
      {{ 'my-home.my-market-overview.leverage' | transloco }}
    </span>
  </a>
</ng-template>
